import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendations from './components/HotRecommendations';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '牛牛影视 - 首页',
          'description': '牛牛超清不缓冲流畅播放，高清电影电视剧免费在线观看全集',
          'url': 'https://www.niuniuyingshi.com/',
          'mainEntity': {
            '@type': 'Organization',
            'name': '牛牛影视',
            'url': 'https://www.niuniuyingshi.com/',
          },
        }),
      }} />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommendations />
        <CategoryShowcase />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}